import * as action from '@/store/action-types'
import templateId from './template-id'
import windowProps from './window-props'

export default {
  mixins: [templateId, windowProps],
  mounted () {
    this.$shortcut.setContext(this.windowId)
    this.$shortcut.bind('f5', () => this.$store.dispatch(action.TOGGLE_PLAY_STOP, {
      templateId: this.templateId, channelId: 'preview'
    }))
    this.$shortcut.bind('f6', () => this.$store.dispatch(action.COMMAND_UPDATE, {
      templateId: this.templateId, channelId: 'preview'
    }))
    this.$shortcut.bind('f7', () => this.$store.dispatch(action.COMMAND_NEXT, {
      templateId: this.templateId, channelId: 'preview'
    }))
    this.$shortcut.bind('f9', () => this.$store.dispatch(action.TOGGLE_PLAY_STOP, {
      templateId: this.templateId, channelId: 'program'
    }))
    this.$shortcut.bind('f10', () => this.$store.dispatch(action.COMMAND_UPDATE, {
      templateId: this.templateId, channelId: 'program'
    }))
    this.$shortcut.bind('f11', () => this.$store.dispatch(action.COMMAND_NEXT, {
      templateId: this.templateId, channelId: 'program'
    }))
  }
}



// WEBPACK FOOTER //
// ./src/mixins/template.js